import { ApiClient, ApiClientWithAuth } from '@/services/api/client'
import { log } from '@/util/log'
import { Either, left, right } from 'fp-ts/lib/Either'

export class SubscriptionPaymentHistoryService {
  constructor (
    private readonly apiClient: typeof ApiClient = ApiClientWithAuth
  ) {}
  async list(): Promise<Either<Error, SubscriptionPaymentHistoryListResponse>> {
    const target = `/api/user/paid_membership/subscription_payment_history`

    try {
      const response = await this.apiClient.get(target)

      log.debug({ service: target, response })

      return right(response.body)
    } catch (error) {
      log.error({ service: target, error })

      return left(error)
    }
  }
}

export interface SubscriptionPaymentHistory {
  id: string
  paymentId: string
  paymentLabel: string
  paymentDate: string
  totalPrice: number
}

export interface SubscriptionPaymentHistoryListResponse {
  data: SubscriptionPaymentHistory[]
}
